import { render, staticRenderFns } from "./seniorReview.vue?vue&type=template&id=2ed658cd&scoped=true&"
import script from "./seniorReview.vue?vue&type=script&lang=js&"
export * from "./seniorReview.vue?vue&type=script&lang=js&"
import style0 from "./seniorReview.vue?vue&type=style&index=0&id=2ed658cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed658cd",
  null
  
)

export default component.exports